import { getJSONfromDOM } from '@pixelcabin/ui-utils';

export default {
  beforeCreateVueInstance(RootComponentDefinition) {
    try {
      const instanceId =
        RootComponentDefinition.el.parentElement.dataset.instanceId;
      const initialData = getJSONfromDOM([
        `#pxl-product-metadata-${instanceId}`
      ]);
      const { propsData } = RootComponentDefinition;

      const { metadata } = initialData;

      RootComponentDefinition.propsData = {
        ...propsData,
        metadata
      };
    } catch (err) {
      console.warn(err);
    }

    return RootComponentDefinition;
  }
};
